import { getRequest } from '../api-handler';
import { PalletDetailDto } from './pallet';

export const PalletApi = {
  getById: (id: number) => getRequest<PalletDetailDto>(`/pallets/${id}`)
};
